import React from 'react';
import './SGDSMastfooter.css';

export default function SGDSMastfooter({hasFixedBottom}) {
  const showMastFooter = true;
  window.location.hostname?.toLowerCase()?.endsWith('.gov.sg');
  return (
    showMastFooter && (
      <div>
        <footer class="sgds-footer">
          <div class={`bottom-section ${hasFixedBottom ? 'has-fixed-bottom' : ''}`}>
            <div class="sgds-container is-fluid">
              <div class="row is-multiline">
                <div class="col is-12">
                  <ul>
                    <li>
                      <a
                        href="https://tech.gov.sg/report_vulnerability"
                        target="_blank"
                        rel="noreferrer">
                        Report Vulnerability
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.csc.gov.sg/privacy/"
                        target="_blank"
                        rel="noreferrer">
                        Privacy
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.csc.gov.sg/terms-of-use/"
                        target="_blank"
                        rel="noreferrer">
                        Terms of Use
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  );
}
